import React from 'react';
import {SelectChangeEvent, useMediaQuery} from '@mui/material';
import SimpleSelect from '../../../SimpleSelect';
import {assetSizes} from '../../../constants/securspace-constants';

const ASSET_SIZE_OPTIONS = assetSizes.map((s: string) => ({value: s, label: `${s}'`}));

interface AssetSizeSelectProps {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  required?: boolean;
}

/**
 * Asset Size dropdown using SimpleSelect.
 * Options are derived from the `assetSizes` constant (20, 40, 45, 50, 53).
 * Uses the native picker on touch devices (see SimpleSelect `native`).
 */
const AssetSizeSelect: React.FC<AssetSizeSelectProps> = ({value, onChange, required}) => {
  const isTouch = useMediaQuery('(pointer: coarse)');
  return (
    <SimpleSelect
      id="assetSize"
      name="assetSize"
      label="Asset Size"
      onChange={onChange}
      value={value}
      placeholder="Choose"
      displayEmpty
      options={ASSET_SIZE_OPTIONS}
      required={required}
      native={isTouch}
    />
  );
};

export default AssetSizeSelect;

